/**
 * addressPresenter
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

import get from 'lodash-es/get';
import head from 'lodash-es/head';
import { Presenter } from '../../presenters/presenter';

export class AddressPresenter extends Presenter {
    get type() {
        return this._get('type', () => {
            return get(this.data, 'address_type.data.description');
        });
    }

    get localAddressParts() {
        return [this.data.street_1, this.data.street_2, this.data.town, this.data.county, this.data.post_code].filter(
            Boolean,
        );
    }

    get firstLine() {
        return head(this.localAddressParts);
    }

    get localAddress() {
        return this.localAddressParts.join('\n');
    }

    get localAddressWithoutFirstLine() {
        return this.localAddressParts.splice(1).join('\n');
    }

    get fullAddressParts() {
        return [
            this.data.street_1,
            this.data.street_2,
            this.data.town,
            this.data.county,
            this.data.post_code,
            this.data.country,
        ].filter(Boolean);
    }

    get googleMapsUrl() {
        if (this.data.lat && this.data.lng) {
            return `https://www.google.com/maps/search/?api=1&query=${this.data.lat},${this.data.lng}`;
        }

        return `https://www.google.com/maps/search/?api=1&query=${this.fullAddressParts.join(',')}`;
    }

    get fullAddress() {
        return this.fullAddressParts.join('\n');
    }
}
